import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { SCol, SRow, SIcon } from '@avalara/skylab-sdk/react';
import { setProgressBarCurrentStep } from '@avalara/bat-apps-shared/client/actions/progress-bar';
import FormInput from '../../../containers/shared/forms/form-input';
import { setCurrentOfferPage } from '../../../store/offer';
import { goToNextOfferStep } from '../../../lib/side-effects/offer-flow';
import { stepNames } from '../../../lib/side-effects/progress-bar';
import { isOfferFormOneIncomplete } from '../../../lib/shared-signup';
import { selectState } from '../../../selectors';
import { isEmbeddedSelector } from '../../../selectors/offer';
import PasswordInput, { strongPasswordText } from '../../shared/password-input';
import { FormContainer } from '../styled/forms';
import SignInLink from '../sign-in-link';
import { Pages } from '../../../../shared/types/offers';
const GetStarted = ({ flow }) => {
    const { offer: { allowedUsers, initializeNewAccounts, offerFlow, }, sharedSignup, } = useSelector(selectState);
    const isEmbedded = useSelector(isEmbeddedSelector);
    const dispatch = useDispatch();
    const history = useHistory();
    const disabled = isOfferFormOneIncomplete(sharedSignup, initializeNewAccounts);
    useEffect(() => {
        dispatch(setCurrentOfferPage(Pages.GetStarted));
        const progressBarStep = initializeNewAccounts
            ? stepNames.createYourAccount
            : stepNames.nameAndEmail;
        dispatch(setProgressBarCurrentStep(progressBarStep));
    }, []);
    const handleClick = () => {
        if (offerFlow)
            dispatch(goToNextOfferStep({ history }));
        else if (flow)
            history.push({ pathname: `/${flow}/company`, search: window.location.search });
    };
    let headingText = 'Get started in three easy steps';
    if (initializeNewAccounts)
        headingText = 'Create your account';
    else if (offerFlow === 'ioss')
        headingText = 'Tell us about yourself';
    return (React.createElement(FormContainer, { isEmbedded: isEmbedded },
        React.createElement("h1", { "data-ref": 'offer.get-started-header' }, headingText),
        allowedUsers !== 'NEW' && React.createElement(SignInLink, null),
        React.createElement("form", { "aria-label": 'form for name and email' },
            React.createElement(SRow, null,
                React.createElement(SCol, { span: '6', className: 'pad-right-sm' },
                    React.createElement("label", { htmlFor: 'firstName' }, "First name"),
                    React.createElement(FormInput, { fieldName: 'firstName', addPadding: true })),
                React.createElement(SCol, { span: '6' },
                    React.createElement("label", { htmlFor: 'lastName' }, "Last name"),
                    React.createElement(FormInput, { fieldName: 'lastName', addPadding: true }))),
            React.createElement(SRow, null,
                React.createElement(SCol, { span: '6', className: 'pad-right-sm' },
                    React.createElement("label", { htmlFor: 'email' }, "Email"),
                    React.createElement(FormInput, { fieldName: 'email', addPadding: true, type: 'email', validateDuringInput: true })),
                React.createElement(SCol, { span: '6' },
                    React.createElement("label", { htmlFor: 'companyName' }, "Company name"),
                    React.createElement(FormInput, { fieldName: 'companyName', addPadding: true, validateDuringInput: true }))),
            initializeNewAccounts && React.createElement(SRow, null,
                React.createElement(SCol, { span: '6', className: 'pad-right-sm margin-bottom-md' },
                    React.createElement("label", { htmlFor: 'password' }, "Create a password"),
                    React.createElement("p", { className: 'margin-bottom-sm' }, strongPasswordText),
                    React.createElement(PasswordInput, { marginAboveError: '12px' })))),
        React.createElement("button", { className: 'primary icon-trailing', "data-ref": 'offer.get-started-button', disabled: disabled, onClick: handleClick },
            "Next ",
            React.createElement(SIcon, { name: 'arrow-circle-right' }))));
};
export default GetStarted;
